import * as type from './mutation-types'

//登录保存信息
export const getUserInfo = ({ commit },data) => {
    commit (type.GET_USER_INFO,data)
}
//登录
export const userLogin = ({ commit },data) => {
    commit (type.USER_LOGIN,data)
}
//系统select
export const getProjects = ({ commit },data) => {
    commit (type.GET_PROJECTS,data)
}
//所有应用
export const getAllApp = ({ commit },data) => {
    commit (type.GET_ALL_APP,data)
}
//系统id切换
export const changeProjectId = ({ commit },data) => {
    commit (type.FILTER_PROJECT_ID,data)
}
//所有分类
export const getAllCategory = ({ commit },data) => {
    commit (type.GET_ALL_CATEGORY,data)
}